import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQ = [
  ["Comment obtenir un devis ou prendre rendez-vous ?",
    "Nous sommes 100 % connectés ! Vous pouvez nous contacter par e-mail, par SMS directement sur le numéro du garage, ou via nos différents réseaux sociaux. Choisissez le canal qui vous convient le mieux, nous sommes très réactifs sur le digital."],
  ["Que devient la cartographie d'origine de mon véhicule ?",
    "Avant toute reprogrammation, nous effectuons une sauvegarde de votre fichier d'origine. Ces archives sont conservées de manière illimitée sur plusieurs espaces de stockage sécurisés. La remise à l'état d'origine du véhicule est tout à fait possible sur rendez-vous (prestation facturée 50 €). Nous gérons également les spécificités constructeurs, comme la remise en place des « patchs de garantie » (notamment sur les véhicules BMW)."],
  ["Y a-t-il des véhicules ou des interventions que vous refusez ?",
    "Oui, nous n'effectuons aucune intervention sur les véhicules électriques et hybrides."],
  ["Proposez-vous un véhicule de prêt pendant les travaux ?",
    "Notre entreprise étant en plein développement, nous ne disposons pas encore de véhicule de courtoisie (c'est un projet à venir). Les prestations de cartographie ou de grosse mécanique demandant souvent une immobilisation de 2 à 3 jours, nous vous invitons à anticiper vos solutions de mobilité."],
  ["Quels sont les moyens de paiement acceptés ?",
    "Nous acceptons les règlements par carte bancaire, en espèces et par virement bancaire. Des solutions de paiement fractionné (en plusieurs fois) sont en cours de mise en place et seront très prochainement disponibles."],  ["Quelle est votre politique de garantie ?",
    "En tant que professionnel de l'automobile, toutes nos interventions sont soumises à l'obligation légale de résultat. Les pièces neuves installées bénéficient de la garantie légale. Concernant l'électronique, notre développement logiciel est garanti."],
  ["Appliquez-vous des frais de gardiennage ?",
    "Oui. Une fois les travaux terminés et que vous en êtes informé, nous vous laissons le temps de vous organiser. Toutefois, à partir du 3ᵉ jour de retard, des frais de gardiennage (généralement 20 € par jour) sont appliqués afin de conserver un espace de stationnement suffisant pour les autres véhicules de l'atelier."],
  ["Y a-t-il des consignes particulières pour déposer mon véhicule ?",
    "Pour toute intervention de reprogrammation, le véhicule doit obligatoirement être déposé avec au minimum un demi-plein de carburant (nécessaire pour la prise de logs et les essais). Pour les cartographies Flexfuel, des frais de carburant supplémentaires peuvent s'appliquer (vous en êtes bien sûr avisé à l'avance)."],
  ["Puis-je attendre au garage pendant la reprogrammation de mon véhicule ?",
    "Non. Afin de vous garantir une prestation sur mesure et sécurisée, nous travaillons exclusivement via des sessions d'enregistrement et d'analyse de logs. Ce travail d'ingénierie prend du temps. Une conversion Flexfuel ou un ajustement spécifique nécessite souvent 2 à 3 jours pour que tous les paramètres soient optimisés et testés sereinement, sans précipitation."],
];

const FaqSection = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="border-t border-zinc-900 bg-[#050505]" data-testid="faq-section">
      <div className="mx-auto max-w-[1100px] px-4 md:px-8 py-16 md:py-24">
        <div className="overline mb-3">Questions fréquentes</div>
        <h2 className="text-4xl sm:text-5xl leading-[0.9] text-white">Bon à savoir<br />avant de nous confier votre véhicule</h2>
        <div className="mt-4 h-[3px] w-24 bg-sared" />

        <div className="mt-12 grid gap-px bg-zinc-800">
          {FAQ.map(([q, a], i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="bg-black" data-testid={`faq-item-${i}`}>
                <button onClick={() => setOpen(isOpen ? null : i)}
                        data-testid={`faq-toggle-${i}`}
                        aria-expanded={isOpen}
                        className="w-full flex items-start justify-between gap-6 text-left px-5 md:px-7 py-5 hover:bg-[#0c0c0c] transition-colors">
                  <span className={`font-head text-lg md:text-xl uppercase tracking-wide ${isOpen ? "text-sared" : "text-white"}`}>
                    {q}
                  </span>
                  <span className={`shrink-0 mt-1 border p-1.5 ${isOpen ? "border-sared text-sared" : "border-zinc-700 text-zinc-400"}`}>
                    {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 md:px-7 pb-6 -mt-1 text-sm md:text-base text-zinc-300 leading-relaxed border-l-2 border-sared ml-5 md:ml-7"
                     data-testid={`faq-answer-${i}`}>
                    <span className="block pl-4">{a}</span>
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
